
export default {
  name: 'PageHowItWorks',

  head() {
    return {
      title: 'Our Paddocks',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'With paddocks located throughout the south coast we&lsquo;re confident we&lsquo;ve got a paddock near you.'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Our paddocks',
        image: require('~/assets/images/backgrounds/paddocks-hero-2.jpg'),
        alt: 'Dog in Paw Paddock'
      }
    }
  }
}
